import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";

import { Route as NewStaticRoute } from "./new.static";
import { Route as NewUniqueRoute } from "./new.unique";

import { AddOfferStep1 } from "@/features/CouponCodes/AddOfferStep1";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/new",
)({
  component: NewOfferLayout,
});

function NewOfferLayout() {
  const matches = useMatches();
  const hasChildRoute = matches.some(
    (m) => m.routeId === NewStaticRoute.id || m.routeId === NewUniqueRoute.id,
  );

  if (hasChildRoute) {
    return <Outlet />;
  }

  return <AddOfferStep1 />;
}
